<template>
    <div>
        <div
            v-loading="loading"
            class="confirm_new-wrapper"
            :style="{ width: clientWidth, height: clientHeight }"
        >
            <img ref="img" :src="receipt_bkg" alt="" class="bkgimg" @onload="imgload" />
            <div class="bkgwrap" :style="{ width: clientWidth, height: clientHeight }">
                <div class="bkgwrap_con">
                    <p class="name">{{ detail.member_name }}</p>
                    <p v-if="!loading" class="zp_name">《{{ detail.info.title }}》</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTid } from '@/utils/cookies'
import { zuopinInfo } from '@/api/Tougaos'

export default {
    name: 'ConfirmNew',
    components: {},
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            zuopin_id: this.$route.query.zuopin_id,
            loading: false,
            detail: { member_name: '', info: { title: '' } },
            clientWidth: '900px',
            clientHeight: '1200px'
        }
    },

    computed: {
        receipt_bkg() {
            const src_1 = require('../../assets/images/recepit_bkg.png')
            const src_2 = require('../../assets/images/recepit_bkg_2.png')
            if (!this.detail.status) return ''
            return this.detail.status === 90 ? src_2 : src_1
        }
    },

    created() {
        this.getZuopinInfo(this.zuopin_id)
    },

    methods: {
        imgload() {
            this.clientWidth = this.$refs.img.clientWidth + 'px'
            this.clientHeight = this.$refs.img.clientHeight + 'px'
        },
        getZuopinInfo(id) {
            this.loading = true
            zuopinInfo({ id })
                .then((res) => {
                    if (res.code !== 200) return
                    this.detail = res.data.data
                })
                .finally(() => {
                    this.loading = false
                })
        },

        back() {
            this.$router.go(-1) // 返回上一层
        },

        print() {
            window.print(0)
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.confirm_new-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    position: relative;

    .bkgimg {
        max-width: 900px;
        height: auto;
    }

    .bkgwrap {
        position: absolute;
        top: 0;
        left: 0;
        max-width: 900px;

        .bkgwrap_con {
            padding-top: 58%;
            .name {
                font-weight: 900;
                font-size: 46px;
                text-align: center;
            }
            .zp_name {
                margin: 10px 0;
                text-align: center;
                font-weight: 500;
                font-size: 26px;
            }
        }
    }
}
</style>
